import useApiClient from '../../Base/Hooks/useApiClient';
import apiClient from '../../../Services/ApiClient';

export default function useMeta() {
	const { displayError } = useApiClient();

	const createUserMeta = async (
		userId: string,
		metaKey: string,
		metaValue: string | boolean,
	) => {
		try {
			const result: any = await apiClient.post(`/user/${userId}/meta/`, {
				key: metaKey,
				value: metaValue,
			});
		} catch (e: any) {
			displayError(e);
		}
	};

	const createWorkplaceMeta = async ({
		workplaceId,
		meta,
	}: {
		workplaceId: string;
		meta: { key: string; value: string | boolean | number };
	}) => {
		try {
			const result: any = await apiClient.post(
				`/workplaces/${workplaceId}/meta/`,
				meta,
			);
			return result;
		} catch (e: any) {
			displayError(e);
		}
	};

	return { createUserMeta, createWorkplaceMeta };
}
